import React, { useEffect, useState } from 'react';
import './Countdown.css';

/*
  Countdown component replicating the Figma design for node 298:2427.
  Tailwind classes have been translated to regular CSS (see Countdown.css).
*/

function Countdown() {
  // Target: 9am, 1st December 2026, local time
  const targetDate = new Date(2026, 11, 1, 9, 0, 0, 0); // Month is 0-indexed (11 = December)
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  function getTimeLeft() {
    const now = new Date();
    let diff = targetDate - now;
    if (diff < 0) diff = 0;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    return { days, hours, minutes, seconds };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line
  }, []);

  const segments = [
    { value: timeLeft.days, label: 'days' },
    { value: timeLeft.hours, label: 'hours' },
    { value: timeLeft.minutes, label: 'minutes' },
    { value: timeLeft.seconds, label: 'seconds' },
  ];

  return (
    <section className="countdown-frame">
      <div className="countdown-timer">
        {segments.map(({ value, label }) => (
          <div className="countdown-segment" key={label}>
            <span className="countdown-value">{value}</span>{' '}
            <span className="countdown-label">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}


export default Countdown;
